/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/views/Layout/Layout';
import NoPermissions from '@/views/404/index';
import NoAuthPage from '@/views/404/noAuth';
import { baiDuStatistics } from '@/utils/index';

import nprogress from '@/utils/nprogress';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  redirect: '/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home/index.vue'),
      meta: {
        title: '首页',
        keepAlive: true,
        headNavActive: '/',
      },
    },
    {
      path: '/',
      component: Layout,
      name: 'Layout',
      children: [],
    },
    {
      path: '/changePwd',
      name: 'changePwd',
      component: () => import('@/views/Login/changePwd.vue'),
      meta: {
        title: '修改密码',
        keepAlive: false,
      },
    },
    {
      path: '/consequence',
      component: () => import('@/views/consequence.vue'),
      name: 'consequence',
      meta: {
        hideNfHead: true,
        NavMenuActive: '/consequence',
        keepAlive: false,
      },
    },
    {
      path: '/404',
      component: NoPermissions,
      name: '404',
      meta: {
        hideNfHead: true,
        keepAlive: false,
      },
    },
    {
      path: '/_404',
      component: NoAuthPage,
      name: '_404',
      meta: {
        hideNfHead: true,
        keepAlive: true,
      },
    },
    { path: '*', redirect: '/_404' },
  ],
});

router.beforeEach(async (to, from, next) => {
  // 打开进度条
  nprogress.start();
  baiDuStatistics();
  next();
});

router.afterEach(() => {
  // 在即将进入新的页面组件前，关闭掉进度条
  nprogress.done();
});

export default router;
